<template>
  <div class="container">
    <fm-making-form
      ref="formDataRef"
      style="height: 100%;"
      preview
      :generate-json="false"
      clearable
      :basic-fields="baseSystem.basicFields"
      :advance-fields="baseSystem.advanceFields"
      :layout-fields="baseSystem.layoutFields"
      :custom-fields="baseSystem.customFields"
      :companyList="workConfig.companyList"
      :isFlagDelete="isFlagDelete"
      :customTitle="customTitle"
    >
      <template slot="action"></template>
    </fm-making-form>
  </div>
</template>

<script>
import FormConfig from "./formConfig"; // 表单配置
export default {
  props: {
    tabName: {
      type: String,
      default: ""
    },
    conf: {
      type: Object,
      default: () => {
        return {};
      }
    },
    workConfig: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isFlagDelete: {
      type: Boolean,
      default: true
    },
    isApprover: {
      type: Boolean,
      default: false
    },
    // 自定义表单id
    formId: {
      type: String,
      default: ""
    },
    // 审批样式id
    styleId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      customTitle: FormConfig.customTitle
    };
  },
  computed: {
    formParams() {
      return {
        token: this.workConfig.token,
        projectType: this.workConfig.projectType,
        projectId: this.workConfig.projectId
      };
    },
    baseSystem() {
      let baseSystem = FormConfig.baseSystem;
      let list = ["contacts", "company", "companyDepartments"];
      let singleCompanyList = ["selectUser"];
      let customFields = [];
      customFields = baseSystem.customFields.filter(e => !list.includes(e.el));
      console.log(
        111,
        baseSystem,
        this.workConfig.isSingleCompany,
        customFields
      );
      if (!this.workConfig.isSingleCompany) {
        customFields = baseSystem.customFields.filter(
          e => !singleCompanyList.includes(e.el)
        );
      }
      baseSystem.customFields = customFields;
      return baseSystem;
    }
  },
  watch: {
    conf() {
      this.setJSON();
    }
  },
  mounted() {
    this.setJSON();
  },
  methods: {
    // 初始化表单数据
    setJSON() {
      if (this.conf && this.conf.list && this.conf.list.length > 0) {
        this.$refs.formDataRef.setJSON(this.conf);
        return;
      }
      if (this.formId || this.styleId) {
        let id = this.formId || this.styleId;
        this.getDetailsAuditStyle(id);
        return;
      }
      if (this.isApprover) {
        let params = {
          list: [
            {
              name: "审核结果",
              el: "flag",
              icon: "icon-flow icon-user-check",
              options: {
                defaultValue: "1",
                customClass: "",
                disabled: false,
                labelWidth: 100,
                isLabelWidth: false,
                hidden: false,
                dataBind: true,
                required: true,
                pattern: "",
                remoteFunc: "func_1610958154575",
                remoteOption: "option_1610958154575"
              },
              rules: [
                {
                  required: true,
                  message: "必须填写"
                }
              ],
              type: "custom",
              key: "1610958154575",
              model: "flag"
            },
            {
              name: "审核意见",
              el: "remark",
              icon: "icon-flow icon-shenhexitong",
              options: {
                defaultValue: "",
                width: "100%",
                customClass: "",
                disabled: false,
                labelWidth: 100,
                isLabelWidth: false,
                hidden: false,
                dataBind: true,
                required: false,
                pattern: "",
                remoteFunc: "func_1610958155182",
                remoteOption: "option_1610958155182"
              },
              rules: [],
              type: "custom",
              key: "1610958155182",
              model: "remark"
            },
            {
              name: "附件",
              el: "uploadFile",
              icon: "icon-flow icon-wenjian",
              options: {
                defaultValue: "",
                width: "100%",
                multiple: true,
                limit: 9,
                tip: "",
                customClass: "",
                disabled: false,
                labelWidth: 100,
                isLabelWidth: false,
                hidden: false,
                dataBind: true,
                required: false,
                pattern: "",
                remoteFunc: "func_1610958162214",
                remoteOption: "option_1610958162214"
              },
              rules: [],
              type: "custom",
              key: "1610958162214",
              model: "custom_1610958162214"
            }
          ],
          config: {
            labelWidth: 150,
            labelPosition: "right",
            size: "small",
            customClass: "",
            ui: "element",
            layout: "horizontal",
            labelCol: 3,
            width: "100%",
            hideLabel: false,
            hideErrorMessage: false
          }
        };
        console.log(3333, params);
        this.$refs.formDataRef.setJSON(params);
        return;
      }
    },
    // 审批样式详情
    async getDetailsAuditStyle(id) {
      let result = await this.$axios.get(
        this.workConfig.configApi.getDetailsAuditStyle + id,
        this.formParams
      );
      let datas = result.data;
      let template = JSON.parse(datas.template);
      this.$refs.formDataRef.setJSON(template);
      console.log("审批样式详情", datas, template);
    },
    /**
     * 供父组件使用 获取表单JSON
     */
    getData(isVerify) {
      return new Promise((resolve, reject) => {
        let formData = this.$refs.formDataRef.getJSON();
        let list = formData.list || [];
        list.map(e => {
          let formOperates = 2;
          if (e.options.disabled) {
            formOperates = 1;
          }
          if (e.options.hidden) {
            formOperates = 0;
          }
          e.formId = e.model;
          e.label = e.name;
          e.formOperate = formOperates;
          e.required = e.options.required;
        });
        if (isVerify && list.length === 0) {
          this.$message({
            type: "error",
            message: "表单内容不能为空!"
          });
          reject({ target: this.tabName });
          return;
        }
        resolve({ formData });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
}
</style>
